import { render, staticRenderFns } from "./DriverDetail.vue?vue&type=template&id=59821448&"
import script from "./DriverDetail.vue?vue&type=script&lang=js&"
export * from "./DriverDetail.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports